import React from 'react';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useSiteConfig } from '@/contexts/SiteConfigProvider';
import styles from './index.scss';
import logo from '@/assets/images/logos/logo.png';

const { Header: AntHeader } = Layout;

const Header: React.FC = () => {
  const location = useLocation();
  const { NAVIGATION } = useSiteConfig();

  return (
    <AntHeader className={styles.header}>
      <div className={styles.container}>
        <Link to="/" className={styles.logo}>
          <img src={logo} alt="红鲤科技" />
        </Link>
        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={NAVIGATION.map((item) => ({
            key: item.path,
            label: <Link to={item.path}>{item.name}</Link>,
          }))}
          className={styles.menu}
        />
      </div>
    </AntHeader>
  );
};

export default Header;
